import { InteractionMetadata } from "../models/Model3D";
import { InteractionElement } from "./InteractionElement";

export type InteractionProps = {
  interactions: InteractionMetadata[];
}

export const InteractionElements = (props: InteractionProps) => {
  const { interactions } = props;


  return <>
    {interactions.map(record => <InteractionElement interaction={record} key={`interaction-${record.name}`} />)}
  </>;
}